export default __webpack_public_path__ + "static/media/candle.250be287.png";